// resolve function bef
(function() {
  angular.module('cfn').factory('fieldCoreDataResolver', fieldCoreDataResolver);

  fieldCoreDataResolver.$inject = ['Field'];

  function fieldCoreDataResolver(Field) {
    return function() {
      return coreCommonResolveFunction(Field, true);
    };
  }
})();
